import {
  ButtonProps,
  CSSObject,
  MantineSize,
  MantineTheme,
} from "@mantine/core";
import { TextSizes, textStyleMapping } from "./typography";

export function getButtonStyle(theme: MantineTheme, params: ButtonProps) {
  const { color, size, variant } = params;

  const style: CSSObject = {
    "&[data-loading]": {
      color: theme.white,
      ...(color
        ? {
            backgroundColor: theme.colors[color][Number(theme.primaryShade)],
          }
        : { backgroundColor: theme.colors.brand[Number(theme.primaryShade)] }),
    },
    "&[data-loading]::before": {
      backgroundColor: "transparent",
    },
  };

  if (size === "sm") {
    style.borderRadius = 12;
  }
  if (variant === "outline") {
    const [, , borderColor] = theme.colors.gray;
    style.borderColor = borderColor;
    style.backgroundColor = theme.white;
  }
  return style;
}

const buttonTypographyMapping: Record<MantineSize, TextSizes> = {
  xs: "button-small",
  sm: "button-small",
  md: "button-medium",
  lg: "button-large",
  xl: "button-large",
};

export function getButtonLabelStyle(
  //t: MantineTheme,
  params: ButtonProps
): CSSObject {
  const sizeKey = params.size as MantineSize;
  const typographyKey = buttonTypographyMapping[sizeKey];

  // Add defensive checks
  if (!typographyKey) {
    //console.error(`Invalid button size: ${params.size}`);
    return {}; // Return a default style or handle accordingly
  }

  const textStyle = textStyleMapping[typographyKey];
  if (!textStyle) {
    console.error(`No text style found for typography key: ${typographyKey}`);
    return {}; // Return a default style or handle accordingly
  }

  const { style } = textStyle;
  return {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
    letterSpacing: "0.03em",
    ...style,
  };
}
